// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3ORGp","modalForm":"UpgradeEpcsModal_modalForm__1u4Tc","modalFooter":"UpgradeEpcsModal_modalFooter__1ZRj7"};